// extracted by mini-css-extract-plugin
module.exports = {"jumboContainer":"styles_jumboContainer__1QfLw","col":"styles_col__1MDIL","imagePH":"styles_imagePH__2-wgh","button":"styles_button__1qmp5"};